import { render, staticRenderFns } from "./EmployeeProjectsModal.vue?vue&type=template&id=e68d88ec&scoped=true&"
import script from "./EmployeeProjectsModal.vue?vue&type=script&lang=js&"
export * from "./EmployeeProjectsModal.vue?vue&type=script&lang=js&"
import style0 from "./EmployeeProjectsModal.vue?vue&type=style&index=0&id=e68d88ec&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e68d88ec",
  null
  
)

export default component.exports